var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('span',{staticClass:"bolder"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"valueField"},[_c('b',[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }